<div *ngIf="this.form">
    <a (click)="onModalCancel()" class="close-button"><mat-icon class="close-icon">close</mat-icon></a>
    
    <div class="col-sm-8">
      <h3 *ngIf="!this.data.form.get('id').value">Ajouter une société</h3>
      <h3 *ngIf="this.data.form.get('id').value">Modifier une société</h3>

    </div>
   
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    
    <form focusInvalidInput class="row" [formGroup]="this.form" style="display: flex; justify-content: space-between;">

        <div class="col-sm-4">
            <mat-form-field class="full-width">
            <mat-label>Code</mat-label>
            <input matInput type="text" formControlName="code" maxlength="7" required>
                <mat-error *ngIf="form.get('code').hasError('required')">
                Veuillez saisir un code
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-8">
            <mat-form-field class="full-width">
            <mat-label>Libelle</mat-label>
            <input matInput name="libelle" formControlName="libelle" maxlength="30" required>
            <mat-error *ngIf="form.get('libelle').hasError('required')">
                Veuillez saisir un libelle
            </mat-error>
            <mat-error *ngIf="form.get('libelle').hasError('maxlength')">
              Le libelle est trop long
            </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-4">
          <mat-form-field class="full-width">
            <mat-label>SIREN</mat-label>
              <input matInput name="siren" formControlName="siren" maxlength="9">
            </mat-form-field>
        </div>

        <div class="col-sm-8">
          <mat-form-field class="full-width">
          <mat-label>Capital social</mat-label>
          <input matInput name="capitalSocial" formControlName="capitalSocial" maxlength="50">
          </mat-form-field>
        </div>

        

        <div class="col-sm-4">
          <mat-form-field class="full-width">
          <mat-label>RCS</mat-label>
            <input matInput name="rsc" formControlName="rsc" maxlength="50">
          </mat-form-field>
        </div>

        <div class="col-sm-4">
          <mat-form-field class="full-width">
            <mat-label>TVA Intracommunautaire</mat-label>
            <input matInput name="tvaIntraComm" formControlName="tvaIntraComm" maxlength="15" >
            </mat-form-field>
        </div>
        <div class="col-sm-4">
          <app-autocomplete-with-code [(objet)]="activite" name="activite" (objetChange)="onChange($event)"
            libelle="Activité" [objets]="this.data.activites" [required]="true"  [forbiddenNames]="true">
          </app-autocomplete-with-code>
        </div>

        <div class="col-sm-4" [hidden]="!this.form.get('id').value">
          <mat-form-field class="full-width">
            <mat-label>Montant max. autovalidation BC</mat-label>
              <input matInput name="montantMaxAutoValidBC" formControlName="montantMaxAutoValidBC">
            </mat-form-field>
        </div>
             
    </form>
</div>
  
<div class="col-sm-12 row" style="display: flex; justify-content: space-between;">
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
    </div>
  
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button *ngIf="this.data.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Modifier</button>
      <button *ngIf="!this.data.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Ajouter</button>

    </div>
</div>

